<template>
    <teleport to="body">
      <vue-easy-lightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox>
    </teleport>
  <DetailsSkeleton v-if="!legacyDetails" />

  <div v-else>
    <div class="
      grid grid-cols-12
      layout-padding
      mt-[100px]
      h-full
      work-details-container
      py-[40px]
    ">
      <div class="
        xl:col-span-5
        mt-5
        lg:mt-0 lg:col-span-6
        col-span-12
        order-last
        lg:order-first
        h-full
        flex flex-col
        justify-center
        text-section
      ">
        <div class="lg:text-4xl lg:leading-[50px] text-2xl">
          {{ legacyDetails?.data?.title }}
        </div>
        <div>
          <div class="text-lg font-bold mt-6">
            {{ content.legacy }} / {{ content[legacyDetails?.data?.type] }}
          </div>

          <!-- <div class="mt-12">Women Collection , 2004</div> -->
          <div class="mt-6 lg:w-10/12 w-full text-justify desc"  v-html="legacyDetails?.data?.description">
          </div>

          <div class="p-6 lg:w-10/12 w-full bg-primary mt-10" v-if="legacyDetails?.data?.acclaimer||legacyDetails?.data?.acclaimer_description">
            <div class="flex justify-between items-center w-full px-8">
              <div class="flex items-center">
                <a :href="legacyDetails?.data?.link" target="_blank"><img :src="legacyDetails?.data?.logo" class="h-8"
                    alt="acclaim-logo " /></a>

                <div class="mx-4 font-bold">
                  {{ legacyDetails?.data?.acclaimer }}
                </div>
              </div>

            </div>
            <div class="mt-4 px-4" v-html="legacyDetails?.data?.acclaimer_description">
            </div>
          </div>
        </div>
      </div>
      <div class="lg:col-span-6 xl:col-span-7 col-span-12 order-first lg:order-last">
        <!-- <img :src="legacyDetails?.data?.image" alt="slide" class="lg:min-h-[80vh] min-h-[40vh]  sticky top-5" /> -->
        <div :style="`background:url(${legacyDetails?.data?.image})`" class="lg:min-h-[80vh] min-h-[40vh] legacy-main-image  sticky top-5"></div>
      </div>
    </div>
    <div class="layout-padding lg:mb-16 mb-4" v-if="legacyDetails?.data?.gallery.length > 0">
      <div class="flex justify-between items-center my-8">
        <div class="text-3xl">{{ content.gallery }}</div>
        <div class="
          lg:h-20
          h-12
          flex
          justify-between
          items-center
          text-3xl
          bg-primary
          w-max
          transition-all
          duration-700
          cursor-pointer
          lg:min-w-[216px]
          min-w-[120px]
        ">
          <div class="lg:px-8 px-4 lg:py-6 py-2 prev-legacy group">
            <img src="/static/images/icons/arrow-left.svg" alt="arrow-left " class="
              lg:w-8
              w-auto
              h-6
              md:ltr:ml-2 md:rtl:mr-2
              rtl:rotate-180
              md:group-hover:ml-0
              transition-all
              duration-300
            " />
          </div>
          <div class="lg:px-8 px-4 lg:py-6 py-2 next-legacy group">
            <img src="/static/images/icons/arrow-right.svg" class="
              lg:w-8
              w-auto
              h-6
              md:ltr:mr-2 md:rtl:ml-2
              rtl:rotate-180
              md:group-hover:mr-0
              transition-all
              duration-300
            " alt="arrow-left " />
          </div>
        </div>
      </div>
    </div>

    <div class="lg:mb-16 mb-10 layout-padding" v-if="legacyDetails?.data?.gallery.length > 0">
      <swiper :slides-per-view="4" :space-between="80" :breakpoints="breakpoints" :navigation="navigation"
 :loop="true">
        <swiper-slide v-for="image in legacyDetails?.data?.gallery" :key="image" @click="showImgs(image?.image)">
          <div class="legacy-slide-img" :style="`background:url(${image?.image});height:${imageHeight}px;`"></div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore from "swiper";
import { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
SwiperCore.use([Navigation]);
export default {
  props: ["id"],
  inject: ["content"],
  data() {
    return {
      imageHeight: 200,
            imgs: [],
      visible: false,
      index: 0, // default: 0,
      breakpoints: {
        // when window width is >= 320px
        20: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        // when window width is >= 480px
        800: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        // when window width is >= 640px
        1300: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
      navigation: {
        nextEl: ".next-legacy",
        prevEl: ".prev-legacy",
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    legacyDetails() {
      return this.$store.getters["legacy/legacyDetails"];
    },


  },
  watch: {
    legacyDetails() {
      if (this.legacyDetails?.data?.gallery) {
        setTimeout(() => {
          let image = document.querySelector(".swiper-slide");
          this.imageHeight=image.offsetWidth;
        }, 200);
      }
    }
  },
    methods: {
    showImgs(img) {
      this.imgs = img;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
  mounted() {
    this.$store.dispatch("legacy/getLegacy", this.id);

  },
  unmounted() {
    this.$store.dispatch("legacy/resetLegacyDetails");
  },
};
</script>
